import { Loading } from "notiflix";
import { Report } from "notiflix/build/notiflix-report-aio";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaUserPlus } from 'react-icons/fa';
import { MainView } from "../components/layout/main";
import Sidebar from "../components/layout/sidebar/sidebar";
import { ViewTitle } from "../components/reusable";
import { Button, Page } from "../ui";
import { StatsView } from "../components/views";
import { ClientsView } from "../components/websiteClaims/views/clientListView";
import api from "../helpers/apiRequester";
import { getLoginUrl } from "../helpers/authConfig";

function WebsiteClaimsClients() {
  const navigate = useNavigate();
  const [dataReady, setDataReady] = useState(false);
  const [loading, setLoading] = useState(false);
  const [clientData, setClientData] = useState<any>();
  const [clientBreakdownData, setClientBreakdownData] = useState<any>();

  useEffect(() => {
    if (!dataReady && !loading) {
      Loading.circle("Loading...");
      setLoading(true);
      getData();
    }
  }, [dataReady, loading]);

  const getData = async () => {
    try {
      const apiResponse = await api("/pcp-sentinel/all-clients");
      const data = apiResponse.data;
      const collectedClientData = { stats: data.stats };
      setClientData(collectedClientData);
      setClientBreakdownData(data.paginatedClientData);
      setDataReady(true);
      Loading.remove();
    } catch (error: any) {
      console.log(error);
      Loading.remove();
      if (error?.response.status == 401) {
        Report.failure(
          "Session Timed Out",
          "Please log in again to continue.",
          "Okay",
          () => {
            window.location.href = getLoginUrl();
          }
        );
      } else {
        window.location.href = getLoginUrl();
      }
    }
  };

  return (
    <div className="clients">
      <Sidebar />
      <MainView>
        <Page>
          <ViewTitle
            text={"View Sentinel Media PCP Clients"}
            button={
              <Button variant="primary" icon={<FaUserPlus />} onClick={() => navigate("/media-claims/add-client")}>
                Add New Client
              </Button>
            }
          />
        {dataReady && (
          <>
            <StatsView stats={clientData.stats} />
            <ClientsView
              dataViewTitle="Search All Clients"
              dataType="ALL"
              data={clientBreakdownData}
              search={true}
              pagination={false}
            />
          </>
        )}
        </Page>
      </MainView>
    </div>
  );
}

export default WebsiteClaimsClients;
